<script setup></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <g clip-path="url(#clip0_6652_4230)">
      <path
        d="M12.7499 11.9999V13.4999H14.2499"
        stroke="currentColor"
        stroke-width="1.63636"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.7502 17.2499C14.8212 17.2499 16.5002 15.5709 16.5002 13.4999C16.5002 11.4288 14.8212 9.74988 12.7502 9.74988C10.6791 9.74988 9.00017 11.4288 9.00017 13.4999C9.00017 15.5709 10.6791 17.2499 12.7502 17.2499Z"
        stroke="currentColor"
        stroke-width="1.63636"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.75003 16.4999H0.750031V2.99988H17.25V8.24988"
        stroke="currentColor"
        stroke-width="1.63636"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.25003 0.749878V2.99988"
        stroke="currentColor"
        stroke-width="1.63636"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.7499 0.749878V2.99988"
        stroke="currentColor"
        stroke-width="1.63636"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M0.750031 5.99988H17.25"
        stroke="currentColor"
        stroke-width="1.63636"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6652_4230">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
